import React, { useState } from "react";
import api, { API } from "../lib/apiClient";
import { UploadSimple, X } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function PhotoUpload({ value = [], onChange, testid = "photo-upload" }) {
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    try {
      const uploaded = [];
      for (const f of files) {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        uploaded.push(data);
      }
      onChange([...(value || []), ...uploaded]);
    } catch (err) {
      toast.error("Upload failed");
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  const remove = (id) => onChange((value || []).filter((p) => p.id !== id));

  return (
    <div>
      <label data-testid={`${testid}-btn`} className="flex cursor-pointer items-center justify-center gap-2 rounded-sm border border-dashed border-zinc-700 bg-zinc-950 py-3 text-sm text-zinc-400 hover:border-amber-500 hover:text-amber-500 transition-colors">
        <UploadSimple size={18} />
        {busy ? "Uploading..." : "Add photo (camera / gallery)"}
        <input type="file" accept="image/*" multiple className="hidden" onChange={handle} disabled={busy} />
      </label>
      {value?.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-2">
          {value.map((p) => (
            <div key={p.id} className="relative">
              <img src={`${API}/files/${p.id}`} alt="" className="h-16 w-16 rounded-sm border border-zinc-800 object-cover" />
              <button type="button" onClick={() => remove(p.id)} className="absolute -right-1 -top-1 rounded-full bg-rose-500 p-0.5 text-white">
                <X size={12} weight="bold" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
